const s = {
  name: "Food",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,6c0-3.3,2.7-6,6-6s6,2.7,6,6v4c0,3-2.2,5.4-5,5.9V20h2v20H3V20h2v-4.1C2.2,15.4,0,13,0,10V6z M6,2
			C3.8,2,2,3.8,2,6v4c0,2.2,1.8,4,4,4s4-1.8,4-4V6C10,3.8,8.2,2,6,2z M5,38h2V22H5V38z"/>
		<path class="st0" d="M16,40V0h1c5,0,9,4,9,9v15h-4v16H16z M20,24h-2v14h2V24z M24,22V9c0-3.5-2.6-6.4-6-6.9V22H24z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Food
};
